import { Button, Stack } from "@mui/material";
import * as React from "react";
import {
    EditModes,
    useTemplateViewEdit,
} from "src/components/providers/template-view-edit-provider";
import LayersClearIcon from "@mui/icons-material/LayersClear";

const TemplateRemove = ({ templateIndex }: { templateIndex: number }) => {
    const { editView } = useTemplateViewEdit();

    const handleClick = () => {
        if (editView) {
            editView({
                templateIndex,
                editMode: EditModes.removeTemplate,
            });
        }
    };

    return (
        <Stack alignItems="center" justifyContent="center" direction="row">
            <Button
                color="warning"
                startIcon={<LayersClearIcon />}
                onClick={handleClick}
                aria-label="remove section"
            >
                Remove Section
            </Button>
        </Stack>
    );
};

export default TemplateRemove;
